import { Flex, Tooltip, Typography } from "antd"
import { type TextProps } from "antd/es/typography/Text"
import React from "react"

import { budgetFormat } from "../../../../utils/number/budget-format.ts"

const { Text } = Typography

interface BudgetLinesFormatOptions {
  vertical?: boolean
  tooltipTitle?: React.ReactNode
}

export const budgetLinesFormat = (
  actual: number | string | null,
  planned: number | string | null,
  options: BudgetLinesFormatOptions = {}
) => {
  const { vertical = true, tooltipTitle } = options

  const safeActual = Number(actual) || 0
  const safePlanned = Number(planned) || 0

  const getTypeParams = (): TextProps => {
    if (safeActual > safePlanned) return { className: "text-red-500 font-bold" }
    if (safeActual > 0) return { className: "text-teal-600 font-medium" }
    return { className: "text-orange-500" }
  }

  const defaultTooltipTitle = (
    <Flex vertical gap={2}>
      <Text className="text-white text-xs">
        Actual: {budgetFormat(safeActual)}
      </Text>
      <Text className="text-white text-xs">
        Planned: {budgetFormat(safePlanned)}
      </Text>
    </Flex>
  )

  const resolvedTooltip = tooltipTitle ?? defaultTooltipTitle

  if (!vertical) {
    return (
      <Tooltip title={resolvedTooltip}>
        <Flex align="baseline" justify={"center"} gap={4}>
          <Text {...getTypeParams()}>{budgetFormat(safeActual)}</Text>
          <Text type="secondary">{`/ ${budgetFormat(safePlanned)}`}</Text>
        </Flex>
      </Tooltip>
    )
  }

  return (
    <Tooltip title={resolvedTooltip}>
      <Flex vertical className="text-center">
        <Text {...getTypeParams()}>{budgetFormat(safeActual)}</Text>
        <Text type="secondary" className="text-xs">
          {`/ ${budgetFormat(safePlanned)}`}
        </Text>
      </Flex>
    </Tooltip>
  )
}
